<template>
  <section class="p-reset">
    <el-form v-if="changed">
      {{ $t('pages.account.resetSuccess') }}
      <el-button @click="backToLogin">{{ $t('pages.account.back_to_login') }}</el-button>
    </el-form>
    <el-form :model="userReset" ref="resetForm" :rules="resetPasswordRules" label-width="100px"  v-else>
      <el-form-item  :label="$t('common.oldPassword')" prop="current_password" >
        <el-input v-model="userReset.current_password" type="password"></el-input>
      </el-form-item>
      <el-form-item :label="$t('common.password')" prop="password">
        <el-input v-model="userReset.password" type="password"></el-input>
      <el-row class="random-psw">
        <el-button type="text" @click="createRandomPassword()">{{ $t('common.random_password') }}</el-button>
        <code>{{ randomPassword }}</code>
      </el-row>
      </el-form-item>
      <el-form-item :label="$t('common.confirmPassword')" prop="confirm_password">
        <el-input v-model="userReset.confirm_password" type="password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="submitResetPassword" type="primary">{{ $t('common.resetPassword') }}</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
  export default {
    data() {
      const pwValidator = (rule, value, cb) => {
        const ptn = this.$consts.PASSWORD_REGEXP;
        if (value === '') {
          cb(new Error(this.$t('common.passwordPlaceholder')));
        } else if (!ptn.test(value)) {
          cb(new Error(this.$t('rules.password_format')));
        } else {
          cb();
        }
      };
      const pwConfirmValidator = (rule, value, cb) => {
        if (value === '') {
          cb(new Error(this.$t('common.passwordPlaceholder')));
        } else if (value !== this.userReset.password) {
          cb(new Error(this.$t('rules.password_repeat')));
        } else {
          cb();
        }
      };
      return {
        randomPassword: '',
        userReset: {
          appKey: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
          current_password: '',
          password: '',
          confirm_password: '',
        },
        changed: false,
        resetPasswordRules: {
          current_password: [
            { required: true, message: this.$t('rules.current_password') },
          ],
          password: [
            { required: true, validator: pwValidator },
          ],
          confirm_password: [
            { required: true, validator: pwConfirmValidator },
          ],
        },
      };
    },
    methods: {
      createRandomPassword() {
        this.randomPassword = this.$utils.randomPassword();
        this.userReset.password = this.randomPassword;
        this.userReset.confirm_password = this.randomPassword;
      },
      clearPassword() {
        this.randomPassword = '';
      },
      submitResetPassword() {
        this.$refs.resetForm.validate((validate) => {
          if (validate) {
            this.$http.post('/api/auth/change_password', this.userReset).then((res) => {
              if (res.data.ok) {
                this.changed = true;
              } else {
                this.$message.error(this.$t('pages.account.resetFail'));
              }
            });
          }
          return validate;
        });
      },
      backToLogin() {
        this.$auth.logout().then(() => {
          this.$router.push({ name: 'login' });
        });
      },
    },
    created() {
      console.log(this.$auth.user());
    },
  };
</script>



// WEBPACK FOOTER //
// Account.vue?3789b7c4